module.exports = __webpack_public_path__ + "static/media/ic_redo.580934a4.svg";